module.exports = __webpack_public_path__ + "static/media/logo_white.a618d1a9.png";